import React, { useState } from 'react'
 
 
import DeliveryDispatchCLList from './DeliveryDispatchCLList';
import DeliveryDispatchCLForm from './DeliveryDispatchCLForm';

const DeliveryDispatchCL= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <DeliveryDispatchCLForm addForm={setFromIsShown} update={upData}    sId={serviceId}/>
        ) : (
          <DeliveryDispatchCLList addForm={setFromIsShown} update={setUpData}    sId={setServiceId}/>
        )}  
    </>
  )
}

export default DeliveryDispatchCL